import {useEffect, useState} from 'react';
import axios from 'axios';
import { fetchAISuggestionsProgressAPI, productsSyncAPI } from "../api/axiosRequests";

export function useProductSync(shop: string | null, showToast: (msg: string) => void, fetchRecs: () => Promise<void>) {
    const [syncing, setSyncing] = useState(false);
    const [syncProgress, setSyncProgress] = useState(0);
    const [syncMessage, setSyncMessage] = useState('Preparing sync...');

    useEffect(() => {
        // Initial check for ongoing sync on mount
        const checkOngoingSync = async () => {
            try {
                const res = await fetchAISuggestionsProgressAPI(shop);
                if (res.data.is_products_syncing) {
                    await pollSyncProgress();
                }
            } catch {
                // Handle error silently
            }
        };
        (async () => await checkOngoingSync())();
    }, []);

    // Polling logic extracted into a separate function
    const pollSyncProgress = async () => {
        setSyncing(true);
        setSyncMessage('Sync in progress...');
        const pollInterval = setInterval(async () => {
            try {
                const res = await fetchAISuggestionsProgressAPI(shop);
                const progress = res.data.progress || 0;
                setSyncProgress(progress);
                setSyncMessage(`Syncing products... ${progress}%`);
                if (progress >= 100) {
                    clearInterval(pollInterval);
                    setSyncMessage('Product sync complete');
                    showToast('Product sync complete');
                    await fetchRecs();
                    setSyncing(false);
                }
            } catch {
                clearInterval(pollInterval);
                setSyncMessage('Failed to track sync progress');
                setSyncing(false);
            }
        }, 2000);
    };

    const handleSyncProducts = async () => {
        if (!window.confirm('Sync products from Shopify now? This may take a while.')) return;
        setSyncing(true);
        setSyncProgress(0);
        setSyncMessage('Starting synchronization...');
        try {
            await productsSyncAPI(shop);
            await pollSyncProgress(); // Call the polling function after initiating sync
        } catch {
            showToast('Product sync failed');
            setSyncing(false);
        }
    };

    return { syncing, syncProgress, syncMessage, handleSyncProducts };
}
